// tslint:disable:max-line-length

import React from 'react';

export const DatatypeHome = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8 0l-8 7h2v8h5v-3h2v3h5v-8h2l-8-7z" />
    </svg>
  );
};
